import { useSyncExternalStore } from "react"
import {
    dismissGodeKjopTooltip,
    getGodeKjopNudgeState,
    GodeKjopNudgeState,
    registerKundeavisClickForNudge,
    shouldOpenKundeavis,
    subscribeToGodeKjopNudge,
} from "./godeKjopNudge"

interface UseGodeKjopNudgeResult {
    godeKjopNudgeState: GodeKjopNudgeState
    shouldOpenKundeavis: boolean
    registerKundeavisClick: () => void
    dismissTooltip: () => void
}

const useGodeKjopNudge = (): UseGodeKjopNudgeResult => {
    const godeKjopNudgeState: GodeKjopNudgeState = useSyncExternalStore(
        subscribeToGodeKjopNudge,
        getGodeKjopNudgeState,
    )

    return {
        godeKjopNudgeState,
        shouldOpenKundeavis: shouldOpenKundeavis(godeKjopNudgeState),
        registerKundeavisClick: registerKundeavisClickForNudge,
        dismissTooltip: dismissGodeKjopTooltip,
    }
}

export default useGodeKjopNudge
